/**
 * Time since epoch in seconds. Note that JS dates are ms based, so you will
 * generally have to multiply this by 1000 when parsing.
 */

import { DateTime } from 'luxon';

import { Iso8601DateString } from 'lib/types';
import { assertNever } from 'lib/utils/types';

export type UnixTime = number;

export enum Period {
  Hour = 'hour',
  Month = 'month',
  Day = 'day',
  Week = 'week',
}

export function findPeriodEnd(start: Iso8601DateString, period: Period) {
  const dateStart = DateTime.fromISO(start);
  switch (period) {
    case Period.Month:
      dateStart.plus({ month: 1 });
      break;
    case Period.Day:
      dateStart.plus({ day: 1 });
      break;
    case Period.Week:
      dateStart.plus({ days: 7 });
      break;
    case Period.Hour:
      dateStart.plus({ hours: 1 });
      break;
    default:
      assertNever(period);
  }
  // Subtract a single second to keep us within the period
  dateStart.minus({ second: 1 });
  return dateStart.toISO();
}
